<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import Alert from "@/dsComponents/Alert/Alert.vue";
import ButtonAlt from "@/dsComponents/buttons/ButtonAlt.vue";
import Modal from "@/dsComponents/modals/Modal.vue";

interface RepublishUnavailableModalProps {
    open: boolean;
    delayHours?: number;
}

const props = withDefaults(defineProps<RepublishUnavailableModalProps>(), {
    delayHours: 24,
});

const emit = defineEmits<{
    close: [];
}>();

const { t } = useI18n();

const message = computed(() => t("modals.companyNeed.republishUnavailable.message", { hours: props.delayHours }));

const handleClose = () => emit("close");
</script>

<template>
    <Modal :open="open" width="500px" :title="t('modals.companyNeed.republishUnavailable.title')" @close="handleClose">
        <div class="republish-unavailable">
            <Alert icon="clock" variant="yellow" :message="message" />
        </div>
        <template #footer>
            <div class="republish-unavailable__footer">
                <ButtonAlt variant="filled" @click="handleClose">
                    {{ t("modals.companyNeed.republishUnavailable.confirm") }}
                </ButtonAlt>
            </div>
        </template>
    </Modal>
</template>

<style scoped lang="scss">
.republish-unavailable {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-xl, 16px);

    &__footer {
        display: flex;
        justify-content: flex-end;
    }
}
</style>
